import { Pipe, PipeTransform } from '@angular/core'
import { ShowtimeType } from './movie.model'

@Pipe({
    name: 'showtimeType'
})

export class ShowtimeTypePipe implements PipeTransform {
    transform(value: ShowtimeType): string {
        return ShowtimeType.toString(value)
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/showtime-type.pipe.ts